import { ContentState, EditorState, convertFromHTML, convertFromRaw, convertToRaw } from 'draft-js'

export const parseEditorContentForSave = (content: ContentState | EditorState | string) => {
  if (!content) return undefined

  if (typeof content === 'string') {
    const blocksFromHTML = convertFromHTML(content)
    return JSON.stringify(
      convertToRaw(ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap)),
    )
  }

  try {
    return JSON.stringify(convertToRaw((content as EditorState)?.getCurrentContent()))
  } catch {
    return JSON.stringify(convertToRaw(content as ContentState))
  }
}

export const parseRemoteEditorContent = (remoteContent: string) => {
  if (!remoteContent) return null

  try {
    return convertFromRaw(JSON.parse(remoteContent))
  } catch {
    const blocksFromHTML = convertFromHTML(remoteContent)
    return ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap)
  }
}

export const getEditorContent = (content: ContentState | EditorState | string) => {
  if (!content) return

  if (typeof content === 'string') return convertFromRaw(JSON.parse(content))

  try {
    return (content as EditorState)?.getCurrentContent()
  } catch {
    return content as ContentState
  }
}
